import React, {
  useContext,
  useRef,
  useLayoutEffect,
  useState,
  useEffect,
} from 'react';
import { AppContext } from '../context';
import PageContent from '../components/PageContent';
import Frame from '../components/Frame';
import Section from '../components/Section';
import { FlatButton } from '../components/Button';
import PaymentErrorModal from '../components/PaymentErrorModal';
import { getQueryParamValue } from '../utils/utils';

const buildAdditionalParameters = clientAccs => {
  if (clientAccs && clientAccs.length > 0) {
    const [acc1, acc2, acc3] = clientAccs;
    let queryParams = '';

    const buildParams = (acc, index) => {
      if (acc) {
        return `&conta${index}=${acc.account}&agencia${index}=${acc.agency}&digito${index}=${acc.dv}&operacao${index}=${acc.operation}`;
      }
      return '';
    };

    queryParams += buildParams(acc1, 1);
    queryParams += buildParams(acc2, 2);
    queryParams += buildParams(acc3, 3);

    return queryParams;
  }
  return '';
};

const isValidCreditCardError = error =>
  [
    'card expired',
    'not authorized',
    'blocked card',
    'card canceled',
    'problems with creditcard',
    'token expirado',
  ].find(curr => curr === decodeURIComponent(error).toLowerCase());

const Payment = ({ history }) => {
  const [modalConfig, setModalConfig] = useState({
    show: false,
    type: '',
  });
  const { proposal, clientAccs, isMobile, setContext } = useContext(AppContext);

  const ref = useRef();

  const frameLink = `${
    proposal.cobranca.confGateway.urlGateWay
  }${buildAdditionalParameters(clientAccs)}`;

  useLayoutEffect(
    () =>
      setContext({
        loading: true,
      }),
    [setContext]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {modalConfig.show && (
        <PaymentErrorModal
          onReject={() => setModalConfig({ ...modalConfig, show: false })}
          type={modalConfig.type}
        />
      )}

      <PageContent className="confirmData" step={isMobile ? 6 : 4} size="1024">
        <Section noPadding>
          <Frame
            title="pagamento"
            scrolling="no"
            onLoad={() => {
              setContext({ loading: false });
              const acceptedPayment = getQueryParamValue(
                ref.current.contentWindow.location.search,
                'situacaoRetorno'
              );
              if (acceptedPayment === 'true') {
                window.dataLayer.push({
                  event: 'id-transacao',
                  id: proposal.identificacao.codigoNegocio,
                  location: window.location.href,
                  time: new Date(),
                  ip: window.ip,
                });

                setContext({
                  payed: acceptedPayment,
                  navigateTo: '/final',
                });
              } else if (acceptedPayment === 'false') {
                const type = getQueryParamValue(
                  ref.current.contentWindow.location.search,
                  'tpPagamento'
                );
                if (
                  type === 'CartaoCredito' &&
                  !isValidCreditCardError(
                    getQueryParamValue(
                      ref.current.contentWindow.location.search,
                      'descricaoRetorno'
                    )
                  )
                ) {
                  setModalConfig({
                    show: true,
                    type: 'unknown',
                  });
                  ref.current.contentWindow.history.back();
                  return;
                }

                setModalConfig({
                  show: true,
                  type,
                });
                ref.current.contentWindow.history.back();
              }
              ref.current.contentWindow.addEventListener(
                'beforeunload',
                () => setContext({ loading: true }),
                false
              );
            }}
            src={frameLink}
            ref={ref}
          />
        </Section>
        <Section flexEnd noPadding bgTransparent inlineChildren>
          <FlatButton
            column
            hasArrow
            arrowDirection="left"
            arrowSize={5}
            back
            onClick={() => history.goBack()}
            margin
          >
            Voltar
          </FlatButton>
        </Section>
      </PageContent>
    </>
  );
};

export default Payment;
